export interface SelfFixApplianceDetails {
  applianceCategory: string;
  applianceCode: string;
  brandCode: string;
}
